import { ChangeDetectionStrategy, Component, ElementRef } from '@angular/core';
import { WizBaseView, WizRoot, WizEventManager, WizEvent } from '@wizeoo/akm-component-lib';
import { ALK_EVENT_TYPE, CmdErrorMessage, PopMaker, SocketIOService, ViewData } from '@wizeoo/akm-common-lib';
import { AllkeyWebWorker } from '@wizeoo/akm-common-lib';
import { Model } from './model/model';
import { WIZ_EVENT_TYPE } from '@wizeoo/akm-core-lib';


/** racine applicative. Toujours présente */
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends WizBaseView {
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  // écouteur websocket
  public socketIOService: SocketIOService;

  public wizSynchronizeData() {

    // signaler que la vue root est UP
    ViewData.getInstance().rootViewInitComplete.next(true); 

    // écouteur sur navigation pour gestion des pops left / right
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_SET_VIEW, Model.getInstance().navigationEngine.addView.bind(Model.getInstance().navigationEngine));
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.NAVIGATE_UNREGISTER, Model.getInstance().navigationEngine.removeView.bind(Model.getInstance().navigationEngine));

    // écouteur global sur le changement de vision
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, Model.getInstance().userContextService.onVisionChanged.bind(Model.getInstance().userContextService) ); 
    
    // écouteur global pour forcer le reload
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.COMPOSITE_RELOAD, Model.getInstance().compositeEngine.compositeReload.bind(Model.getInstance().compositeEngine) ); 
    
    // interception et affichage des erreurs de service
    WizEventManager.addListener(this, WizRoot.root(), WIZ_EVENT_TYPE.CMD_ERR, this.onCommandError);
    
    // demande d'ouverture de popUp par les widgets
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SHOWPOP, PopMaker.openMassPop);
    // demande d'ouverture de popUp par les widgets depuis le header
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SHOWHEADERPOP, PopMaker.openHeaderMassPop);
 
    // initialisation du socketIo
    this.socketIOService = new SocketIOService(Model.getInstance());

    // écouteurs sur websocket
    this.socketIOService.onAKMMessage().subscribe((message: any) => {
      Model.getInstance().socketMessageEngine.do(Model.getInstance().navigationEngine.getCurrentView(), message);
    });

  }

  /**
   * interception des erreurs de service
   */
  private onCommandError(e: WizEvent): void {
    // console.log('cmd error', e.value.error);
    CmdErrorMessage.doMessage(e);
  }

}

/** construction du webWorker */
if (typeof Worker !== 'undefined') {

  const worker = new Worker(new URL('./manager/worker/app.worker', import.meta.url));
  AllkeyWebWorker.webworker = worker;
  // console.log('check app worker', worker);

  AllkeyWebWorker.webworker.postMessage({type:'INIT'});
} else {
  console.log('Web Workers are not supported in this environment');
  // Web Workers are not supported in this environment.
}